'use client';

import React from 'react';
import DoubleOptIn from '@/ui/components/tiles/DoubleOptIn/double-opt-in';
import { DoubleOptInTileType } from '@/ui/components/tiles/DoubleOptIn/types/double-opt-in-tile-type';
import { ElementStyling } from '@/integrations/crystallize/helpers/element-styling-piece-helper';
import PromotionBlock from '../promotion-block/promotion-block';
import { PromotionItem } from './types';

const DOI_DEFAULT_STYLING: Required<ElementStyling> = {
  backgroundColor: '#000000',
  textColor: '#FFFFFF',
  buttonColor: '#FECB3F',
  headlineColor: '#FECB3F',
  footnoteColor: '#757575',
};

type PromotionSlotProps = {
  items: PromotionItem[];
  onPromoDoubleOptInSubmitted?: () => void;
  onPromoVoucherCopy?: () => void;
  onPromoLinkClick?: () => void;
};

function getStylingDefaults(
  styling: ElementStyling,
  defaults: Required<ElementStyling>,
): ElementStyling {
  return {
    backgroundColor: styling.backgroundColor || defaults.backgroundColor,
    textColor: styling.textColor || defaults.textColor,
    buttonColor: styling.buttonColor || defaults.buttonColor,
    headlineColor: styling.headlineColor || defaults.headlineColor,
    footnoteColor: styling.footnoteColor || defaults.footnoteColor,
  };
}

export default function PromotionSlot({
  items,
  onPromoDoubleOptInSubmitted,
  onPromoVoucherCopy,
  onPromoLinkClick,
}: Readonly<PromotionSlotProps>) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full max-w-lg flex-col gap-4">
      {items.map((item) => {
        switch (item.shapeIdentifier) {
          case 'doubleoptin':
            return (
              <DoubleOptIn
                key={item.id}
                tile={item.components as DoubleOptInTileType}
                elementStyling={getStylingDefaults(item.elementStyling, DOI_DEFAULT_STYLING)}
                isForCompatibilityCheckScreen
                onSubmitted={onPromoDoubleOptInSubmitted}
              />
            );
          case 'promotion-block':
            return (
              <PromotionBlock
                key={item.id}
                components={item.components}
                onPromoVoucherCopy={onPromoVoucherCopy}
                onPromoLinkClick={onPromoLinkClick}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
}
